import React, { useState, useContext, useEffect } from 'react';
import { Button, Col, Form, Input, Modal, Row, Select, Card, Table , Checkbox} from 'antd';
import Colors from "../../../styles/Colors";
import { BiCheck, BiX } from "react-icons/bi";
import { AuthContext } from "../../../config/AuthContext";
import {GetUsuaris} from "../../../dao/root/GetUsuaris";
import { Pagina, defaultPagina} from '../../../model/root/Pagina';
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import LlocTreball from '../../../model/root/LlocTreball';
import {PostLlocTreball} from "../../../dao/root/PostLlocTreball";


const { Option } = Select;

interface DuplicarLlocModalProps {
    element: LlocTreball;
    visible: boolean;
    onClose: (value: boolean) => void;
}


const DuplicarLlocModal: React.FC<DuplicarLlocModalProps> = ({ element, visible, onClose }) => {
    const [form] = Form.useForm();
    const { isLoggedIn, userId, user, page } = useContext(AuthContext);
    const [pagines, setPagines] =  useState<any[]>([]);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);
    const [Lloc, setLloc] =  useState<LlocTreball[]>([]);
    const [permisosSeleccionats, setPermisosSeleccionats] = useState<Pagina[]>([]);


    useEffect(() => {
        if (visible) {
            checkDades();
        }
       }, [visible]);
   
    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }
    const handleEmpresaChange = async (empresa: string) => {
        form.setFieldValue("empresa", empresa);
        // Cargar paginas
        const dades = await GetUsuaris(empresa);
        setPagines(dades?.pagines || []);
        
    };
    const handleSubmit = async () => {
        
        const empresaSeleccionada = form.getFieldValue('empresa');
        
        const elementClone = { ...element, id: 0 };
        await PostLlocTreball(elementClone, empresaSeleccionada);
        onClose(true);
    };


    const handleCancel = () => {
        onClose(false);
    };
    
    return (
        <Modal
            title="Duplicar Rol"
            open={visible}
            onCancel={handleCancel}
            footer={[
            ]}
            width={'40%'}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit} >
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item 
                            label={
                                <span>
                                    Escull l'empresa on vols duplicar el Lloc de treball <strong>{element.nom}</strong>
                                </span>
                            }
                            name="empresa" 
                            rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                        >
                            <Select
                                placeholder="Selecciona una empresa"
                                onChange={handleEmpresaChange}
                            >
                                {Array.isArray(empresas) && empresas.map(value =>
                                    <Option key={value.id} value={value.datasource}>
                                        {value.nomEmpresa}
                                    </Option>
                                )}
                            </Select>
                                                                                           
                        </Form.Item>
                    </Col>
                   
                </Row>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default DuplicarLlocModal;